class BlovSwiperSlide extends HTMLElement {
  constructor() {
      super();
      this.casouselSlide = this.querySelector('.blog-list__slideshow');
      new Swiper(this.casouselSlide, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 1000,
          autoHeight: false,
          centeredSlides: false,
          roundLengths: true,
          // Navigation arrows
          navigation: {
              nextEl: '.blog-list-button-next',
              prevEl: '.blog-list-button-prev',
          },
      });
  }
}
customElements.define("blog-list-container", BlovSwiperSlide);
